module.exports = __webpack_public_path__ + "img/country.75b94905.svg";